import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { rcApi, errMsg, today } from "./rcApi";

export const RiderCashAddDialog = ({ employees = [], preset, onClose, onSaved }) => {
  const [q, setQ] = useState("");
  const [f, setF] = useState({ employee_id: preset?.employee_id || "", type: preset?.type || "collect", amount: "", date: today(), method: "cash", note: "" });
  const [busy, setBusy] = useState(false);
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return [];
    return employees.filter((e) => `${e.name} ${e.employee_number || ""} ${e.iqama_number || ""}`.toLowerCase().includes(s)).slice(0, 8);
  }, [q, employees]);
  const sel = employees.find((e) => e.id === f.employee_id);
  const save = async () => {
    if (!f.employee_id || !(Number(f.amount) > 0)) return toast.error("اختر الموظف وأدخل المبلغ");
    setBusy(true);
    try { await rcApi.add({ ...f, amount: Number(f.amount) }); toast.success("تم الحفظ"); onSaved(); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent dir="rtl" className="sm:max-w-md font-body" data-testid="rc-add-dialog">
        <DialogHeader className="text-right"><DialogTitle className="font-heading">إضافة حركة نقد</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {sel ? (
            <div className="flex items-center justify-between rounded-lg bg-slate-50 p-2 text-sm" data-testid="rc-add-selected">
              <span>{sel.name} <span className="text-slate-400">{sel.employee_number}</span></span>
              {!preset?.employee_id && <button className="text-xs text-rose-600" onClick={() => setF({ ...f, employee_id: "" })}>تغيير</button>}
            </div>
          ) : (
            <div>
              <Input data-testid="rc-add-emp-search" placeholder="ابحث بالاسم أو الرقم الوظيفي أو الهوية" value={q} onChange={(e) => setQ(e.target.value)} />
              {list.map((e) => (
                <button key={e.id} data-testid={`rc-add-emp-${e.id}`} onClick={() => setF({ ...f, employee_id: e.id })}
                  className="block w-full rounded px-2 py-1.5 text-right text-sm hover:bg-blue-50">{e.name} <span className="text-slate-400">{e.employee_number}</span></button>
              ))}
            </div>
          )}
          <div className="grid grid-cols-2 gap-2">
            {[["collect", "تحصيل نقد (على المندوب)"], ["deposit", "توريد (من المندوب)"]].map(([v, l]) => (
              <button key={v} data-testid={`rc-add-type-${v}`} onClick={() => setF({ ...f, type: v })}
                className={`rounded-lg border p-2 text-sm transition-colors ${f.type === v ? "border-blue-600 bg-blue-50 text-blue-700" : "border-slate-200"}`}>{l}</button>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Input data-testid="rc-add-amount" type="number" placeholder="المبلغ" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} />
            <Input data-testid="rc-add-date" type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} />
          </div>
          {f.type === "deposit" && (
            <select data-testid="rc-add-method" className="w-full rounded-md border p-2 text-sm" value={f.method} onChange={(e) => setF({ ...f, method: e.target.value })}>
              <option value="cash">استلام نقدي (الصندوق)</option><option value="bank">إيداع بنكي</option>
            </select>
          )}
          <Input data-testid="rc-add-note" placeholder="ملاحظة (اختياري)" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} />
          <Button data-testid="rc-add-save" className="w-full" disabled={busy} onClick={save}>{busy && <Loader2 className="h-4 w-4 animate-spin" />}حفظ</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
